import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { UserService } from '../../user/user.service';
import { OrganizationService } from '../../organization/organization.service';
import { Organization } from '../../organization/organization.model';

import { SearchComponent } from '../../search/search.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public sidebarState: boolean = false;

  menuItems: any[] = [];
  public initials: string = '';

  public completeSubOrgsList: Organization[] = [];

  constructor(
    public userService: UserService,
    public organizationService: OrganizationService
  ) {
  }

  ngOnInit(): void {
    let user = this.userService.userInfo;
    this.initials = user.firstName[0]+user.lastName[0];
    this.organizationService.subOrgsSubject.subscribe((subOrgs) => {
      if (this.completeSubOrgsList.length === 0) this.completeSubOrgsList = subOrgs
    });
  }

  selectTempOrgID(event) {
    console.log(event);
  }

}
